import { Link, Outlet, useRouteLoaderData } from "react-router-dom";

import UserInfo from "../common/userInfo";
import { useAuthStore, User } from "../main/authStore";

import { RentalRecord } from "./types";

export default function RentalStatusDetail() {
    const { rental } = useRouteLoaderData("Rental") as { rental: RentalRecord };
    const user = useAuthStore(state => state.user) as User;
    const canEdit = user.projects !== "no" && rental.void === "no";

    return (
        <div className = "border rounded p-3">
            <div className = "cssSeperateWhenWide">
                <table className = "table table-responsive-xl noTopBorder flex-grow-1 me-3">
                    <tbody>
                        <tr>
                            <th>Status</th>
                            <td><span className = {`badge text-bg-${rental.status === "returned" ? "success" : "primary"}`}>{rental.status}</span></td>
                        </tr>
                        <tr>
                            <th>Equipment</th>
                            <td>{rental.equipmentName}</td>
                        </tr>
                        <tr>
                            <th>Project</th>
                            <td>{rental.projectId ? <Link to = {`/Projects/${rental.projectId}`}>{rental.projectName}</Link> : rental.projectName}</td>
                        </tr>
                        <tr>
                            <th>Technician</th>
                            <td><UserInfo name = {rental.renterName} id = {rental.renterId} /></td>
                        </tr>
                        <tr>
                            <th>Department</th>
                            <td>{rental.department}</td>
                        </tr>
                        <tr>
                            <th>Rental Start Date</th>
                            <td>{rental.rentalStartDate}</td>
                        </tr>
                        <tr>
                            <th>Rental Expire Date</th>
                            <td>{rental.rentalExpireDate}</td>
                        </tr>
                        <tr>
                            <th>Notes</th>
                            <td><span style = {{ whiteSpace: "pre-wrap" }}>{rental.notes}</span></td>
                        </tr>
                    </tbody>
                </table>
                <table className = "table table-responsive-xl noTopBorder flex-grow-1">
                    <tbody>
                        <tr>
                            <th>Returned By</th>
                            <td>{rental.returnedById ? <UserInfo name = {rental.returnedByName} id = {rental.returnedById} /> : ""}</td>
                        </tr>
                        <tr>
                            <th>Return Date</th>
                            <td>{rental.rentalReturnDate}</td>
                        </tr>
                        <tr>
                            <th>Return Notes</th>
                            <td><span style = {{ whiteSpace: "pre-wrap" }}>{rental.returnNotes}</span></td>
                        </tr>
                        <tr>
                            <th>Creator</th>
                            <td><UserInfo name = {rental.creatorName} id = {rental.creatorId} /> <span className = "ms-2">{rental.createdAt}</span></td>
                        </tr>
                        {rental.updaterId ? (
                            <tr>
                                <th>Updater</th>
                                <td><UserInfo name = {rental.updaterName} id = {rental.updaterId} /> <span className = "ms-2">{rental.updatedAt}</span></td>
                            </tr>
                        ) : null}
                    </tbody>
                </table>
            </div>
            <div className = "mt-3">
                {canEdit ? <Link className = "btn btn-outline-primary me-2" to = "Edit">Edit Rental</Link> : null}
                {canEdit ? <Link className = "btn btn-outline-primary" to = "Return">{rental.status === "returned" ? "Edit Return" : "Return"}</Link> : null}
            </div>
            <Outlet />
        </div>
    );
}
